const deleteTenants = {
  toastr: 'tenant deleted',
  toastr1: ' successfully deleted'
};

export default deleteTenants;
